// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useCurrentUser } from '@Queries/userQueries';
import RouteBuilder from '@Services/RouteBuilder';

type PrivateRouteProps = RouteProps & {
    space?: string[];
    shared?: boolean;
};

const LoginRedirect = <Redirect to={RouteBuilder.compute('login.default')} />;

// eslint-disable-next-line
const PrivateRoute = ({ space, shared, ...rest }: PrivateRouteProps): ReactElement | null => {
    const { status } = useCurrentUser();

    if (status === 'error') {
        return LoginRedirect;
    }

    return <Route {...rest} />;
};

export default PrivateRoute;
